<template>
  <Wrap>
    <SkeletonItem v-if="loading" class="breadcrumbs-skeleton" is-animated />
    <UiBreadcrumbs
      v-else-if="crumbs.length"
      :list="crumbs"
      :events-identifier="eventsIdentifier"
      :track-event="breadcrumbsTrackEvent"
    />
  </Wrap>
</template>

<script setup lang="ts">
import { UiBreadcrumbs, type IUiBreadcrumbItem, type TrackEvent } from '@experience/core-breadcrumbs-ui';
import { SkeletonItem } from '@experience/core-skeleton-lib';
import { ref } from 'vue';

import { useAnalytics } from '@/shared/lib/analytics';
import Wrap from '@/shared/ui/Wrap.vue';

defineProps<{
  /** Крошки из ответа BFF. */
  crumbs: IUiBreadcrumbItem[];
}>();

const loading = ref(false);
const { trackEvent } = useAnalytics();
const breadcrumbsTrackEvent: TrackEvent = trackEvent;

const eventsIdentifier = 'attraction-card';
</script>

<style lang="scss" scoped>
.breadcrumbs-skeleton {
  width: 260px;
  height: 34px;
  margin: 7px 1px;

  @include tablet {
    width: 100px;
  }
}
</style>
